// App.js
import React, { useState } from 'react'
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'
import SensorDashboard from './features/dashboard/solid-dashBoard/SensorDashboard'
import AboutPage from './features/about/AboutPage'
import TerminalPage from './features/Terminal/TerminalPage'
import TroubleShootingPage from './features/diagnostics/TroubleShootingPage'
import PublicDashboard from './public dashboard/PublicDashboard'
import LoginModal from './components/LoginModal'
import { DiagnosticsProvider } from './features/diagnostics/DiagnosticsContext'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import './App.css'
import logo from './assets/66d7703c9b0547.05944640-1.jpg'

// Main app content component that uses auth context
function AppContent() {
  const { accessTier, isAuthenticated, logout, hasAccess, ACCESS_TIERS } = useAuth()
  const [showLoginModal, setShowLoginModal] = useState(false)

  const handleLoginClick = () => {
    setShowLoginModal(true)
  }

  const handleLogout = () => {
    logout()
  }

  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <img src={logo} alt="Logo" style={{ height: '60px', marginRight: '1rem' }} />
          
          {/* Navigation - conditional based on access tier */}
          <nav style={{ display: 'flex', gap: '1.5rem', marginLeft: '2rem', flex: 1 }}>
            <Link to="/" className="App-link">
              {accessTier === ACCESS_TIERS.PUBLIC ? 'Ocean pCO₂ Monitor' : 'Dashboard'}
            </Link>
            
            {hasAccess(ACCESS_TIERS.STANDARD) && (
              <>
                <Link to="/about" className="App-link">About</Link>
                <Link to="/terminal" className="App-link">Terminal Interface</Link>
                <Link to="/troubleshooting" className="App-link">Troubleshooting</Link>
              </>
            )}
          </nav>

          {/* Auth controls */}
          <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
            {accessTier === ACCESS_TIERS.PUBLIC ? (
              <button
                onClick={handleLoginClick}
                style={{
                  padding: '0.5rem 1rem',
                  backgroundColor: '#007bff',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontWeight: '500'
                }}
              >
                Access Full Dashboard
              </button>
            ) : (
              <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                <span style={{ 
                  color: '#6c757d', 
                  fontSize: '0.9rem',
                  textTransform: 'capitalize'
                }}>
                  {accessTier} Access
                </span>
                <button
                  onClick={handleLogout}
                  style={{
                    padding: '0.4rem 0.8rem',
                    backgroundColor: '#6c757d',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '0.9rem'
                  }}
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        </header>

        <Routes>
          <Route path="/" element={
            accessTier === ACCESS_TIERS.PUBLIC 
              ? <PublicDashboard /> 
              : <SensorDashboard />
          } />
          
          {hasAccess(ACCESS_TIERS.STANDARD) && (
            <>
              <Route path="/about" element={<AboutPage />} />
              <Route path="/terminal" element={<TerminalPage />} />
              <Route path="/troubleshooting" element={<TroubleShootingPage />} />
            </>
          )}
          
          {/* Redirect unauthorized access to public view */}
          <Route path="*" element={
            accessTier === ACCESS_TIERS.PUBLIC 
              ? <PublicDashboard /> 
              : <SensorDashboard />
          } />
        </Routes>

        <LoginModal 
          isOpen={showLoginModal} 
          onClose={() => setShowLoginModal(false)} 
        />
      </div>
    </Router>
  )
}

function App() {
  return (
    <AuthProvider>
      <DiagnosticsProvider>
        <AppContent />
      </DiagnosticsProvider>
    </AuthProvider>
  )
}

export default App
